import type { FC } from 'react';
import { Inline, TextHighlighter } from '@george-labs.com/design-system';

interface Props {
    text: string;
    highlightedText?: string;
    dataCy?: string;
}

export const TextWithOptionalHighlight: FC<Props> = ({ text, highlightedText, dataCy }) => {
    if (highlightedText) {
        return <TextHighlighter data-cy={dataCy} highlight={highlightedText} text={text} />;
    }

    return <Inline data-cy={dataCy}>{text}</Inline>;
};
